<div class="contact-us-container">
    <div class="contact-info" [class.open]="isOpen">
        <span class="contact-item">Version: {{ version }}</span>
        <a href="mailto:analytics@senzime.com" class="contact-item">
            <span class="material-symbols-rounded" aria-hidden="true">mail</span>
            <span>analytics&#64;senzime.com</span>
        </a>
    </div>
    <button type="button" class="contact-button" (click)="toggle()" [attr.aria-expanded]="isOpen">
        <span class="material-symbols-rounded" aria-label="Contact us">contact_support</span>
    </button>
</div>
